import axios from 'axios'
import appConfig from '@/appconfig'
import endpoint from '@constants/apipath'

export const actions = {
  fetchOTPOptions({ commit }, { tokenId } = {}) {
    var url = `${appConfig.apiEndPoint}${endpoint.identityApiPath.getotpoptions}/${tokenId}`
    const headers = {
      'Content-Type': 'application/json',
      Authorization: axios.defaults.headers.common.Authorization,
    }
    return axios
      .get(url, {
        headers: headers,
      })
      .then((response) => {
        return response
      })
      .catch((error) => {
        if (error.Response && error.Response.status === 401) {
          return null
        }
        return null
      })
  },

  sendotp({ commit }, { tokenId, notificationType, isforgotUserName } = {}) {
    if (isforgotUserName === undefined) {
      isforgotUserName = false
    }
    var url = `${appConfig.apiEndPoint}${endpoint.identityApiPath.forgotpasswordotp}/${tokenId}/${notificationType}/${isforgotUserName}`
    const headers = {
      'Content-Type': 'application/json',
      Authorization: axios.defaults.headers.common.Authorization,
    }
    return axios
      .post(url, {
        headers: headers,
      })
      .then((response) => {
        return response
      })
      .catch((error) => {
        if (error.Response && error.Response.status === 401) {
          return null
        }
        return null
      })
  },
  validateotp({ commit }, { tokenId, otp, isforgotUserName } = {}) {
    if (isforgotUserName === undefined) {
      isforgotUserName = false
    }
    var url = `${appConfig.apiEndPoint}${endpoint.identityApiPath.validateotp}/${tokenId}/${otp}/${isforgotUserName}`
    const headers = {
      'Content-Type': 'application/json',
      Authorization: axios.defaults.headers.common.Authorization,
    }
    return axios
      .post(url, {
        headers: headers,
      })
      .then((response) => {
        return response
      })
      .catch((error) => {
        if (error.Response && error.Response.status === 401) {
          return null
        }
        return null
      })
  },
}
